    const modules = {
        Admin_Dashboard: ["edit", "view", "delete"],
        School: ["edit", "view", "delete"],
        Content: ["edit", "view", "delete"],
       
    };

    export default modules